export class ParamsHelper {
  parse(params: object) {
    return '?' + Object.keys(params).filter(p => {
      return !!params[p];
    }).map(p => {
      return `${p}=${encodeURIComponent(params[p])}`;
    }).join('&');
  }
}
